module.exports = __webpack_public_path__ + "img/pens.3b9f1c6a.jpeg";